<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">Trips</h3>
        </b-card-header>

        <el-table class="table-responsive table"
                  header-row-class-name="thead-light"
                  header-cell-class-name="px-1"
                  cell-class-name="px-1 pointer"
                  table-layout="auto"
                  size="small"
                  fit
                  highlight-current-row
                  @current-change="onSelect"
                  :data="trips">
            <el-table-column label="Name"
                             prop="name">
            </el-table-column>
            <el-table-column label="Motorbike"
                             prop="motorbike._name">
            </el-table-column>
            <el-table-column label="Start Date"
                             min-width="50px"
                             prop="_startDate">
            </el-table-column>
            <el-table-column label="End Date"
                             min-width="50px"
                             prop="_endDate">
            </el-table-column>
            <el-table-column label="Days"
                             min-width="30px"
                             prop="_days">
            </el-table-column>
            <el-table-column label="Distance"
                             min-width="30px"
                             prop="_distance">
            </el-table-column>
        </el-table>

        <!-- TODO: implement pagination -->
        <!-- <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="50"></base-pagination>
        </b-card-footer> -->
    </b-card>
</template>
<script>
  import { Table, TableColumn} from 'element-ui'
  import { mapGetters } from 'vuex';
  export default {
    name: 'trips-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    // data() {
    //   return {
    //     currentPage: 1
    //   };
    // },
    computed: {
      ...mapGetters({
        trips: 'trips/items'
      })
    },
    methods: {
      onSelect(newValue) {
        this.$router.push({name: 'trip', params: {id: newValue._id}})
      }
    }
  }
</script>
